import repository from "@/plugins/axios/secureClient";

const roleResource = "/roles";

export default {
  getPermissions() {
    return repository.get(`${roleResource}/permissions`);
  },
  createRole(data) {
    return repository.post(`${roleResource}`, data);
  },
  updateRole(data, roleId) {
    return repository.put(`${roleResource}/${roleId}`, data);
  },
  getRole(roleId) {
    return repository.get(`${roleResource}/${roleId}`);
  },
  deleteRole(roleId) {
    return repository.delete(`${roleResource}/${roleId}`);
  },
  paginateRoles(params) {
    return repository.get(`${roleResource}/`, { params });
  },
  getAllRoles() {
    return repository.get(`${roleResource}/all`);
  },
  getHistoryById(id) {
    return repository.get(`${roleResource}/${id}/history`);
  }
};
